// extracted by mini-css-extract-plugin
module.exports = {"menu":"e_KD","alignRight":"e_LD","alignLeft":"e_MD","item":"e_ND","icon":"e_OD","soft":"e_PD"};